import type {Point} from '@yandex-delivery/core/types'

import type {AppConfig} from '../../../types'

export function getPointLocation({
  initialProps,
  location,
  isSource,
}: {
  initialProps: AppConfig['initialProps']
  location: Point
  isSource: boolean
}) {
  if (isSource) {
    if (initialProps?.from) return initialProps?.from

    return !!initialProps?.zoneName ? initialProps.zonePoint : location
  }
  return initialProps?.to
}
